export default "__VITE_ASSET__f6757d8e__"